export default __webpack_public_path__ + "static/media/icon-info-orange.83372a69.svg";